export default __webpack_public_path__ + "static/media/ic-art-insulin.ba9ad576.svg";